/**
 * F-locale-es (CEO 2026-09-18) — ESPANHOL, mesma estratégia do ucraniano
 * (messages.uk.ts): tradução completa do que o técnico vê (login/auth,
 * comuns e o portal do técnico); o resto do ERP faz fallback para o
 * FRANCÊS via spread em messages.ts.
 */

import type { Messages } from "./messages.js";
import type { PagesMessages } from "./messages.pages.js";

export const esCommon: Messages["common"] = {
  loading: "Cargando…",
  cancel: "Cancelar",
  submit: "Enviar",
  back: "Volver",
  next: "Siguiente",
  previous: "Anterior",
  save: "Guardar",
  close: "Cerrar",
  logout: "Salir",
  logoutPending: "Saliendo…",
  showPassword: "Mostrar contraseña",
  hidePassword: "Ocultar contraseña",
  requiredField: "Campo obligatorio",
};

export const esLangSwitcher: Messages["langSwitcher"] = {
  ariaLabel: "Idioma",
};

export const esAuth: Messages["auth"] = {
  subtitle: "Sistema de gestión",
  emailLabel: "Correo electrónico",
  emailPlaceholder: "su@email.com",
  passwordLabel: "Contraseña",
  passwordPlaceholder: "••••••••",
  newPasswordLabel: "Nueva contraseña",
  confirmPasswordLabel: "Confirmar contraseña",
  nameLabel: "Nombre completo",
  submitLogin: "Entrar",
  submitLoginPending: "Entrando…",
  submitForgot: "Enviar enlace",
  submitForgotPending: "Enviando…",
  submitReset: "Restablecer contraseña",
  submitResetPending: "Restableciendo…",
  submitAccept: "Aceptar invitación",
  submitAcceptPending: "Aceptando…",
  forgotPasswordLink: "¿Olvidó su contraseña?",
  backToLoginLink: "Volver al inicio de sesión",
  forgotTitle: "Recuperar contraseña",
  forgotDescription: "Escriba su correo y le enviaremos un enlace para restablecer la contraseña.",
  forgotSent: "¡Enviado! Revise su correo.",
  resetTitle: "Definir nueva contraseña",
  resetDescription: "Elija una contraseña segura (mínimo 8 caracteres).",
  resetSuccess: "Contraseña restablecida con éxito. Redirigiendo…",
  acceptTitle: "Aceptar invitación",
  acceptDescription: "Cree su contraseña para completar el registro.",
  acceptSuccess: "¡Registro completado! Redirigiendo…",
  errorPasswordsDoNotMatch: "Las contraseñas no coinciden.",
  errorTokenInvalid: "Enlace inválido o caducado.",
};

export const esTechPortal: PagesMessages["techPortal"] = {
  title: "Portal del Técnico",
  logout: "Salir",
  rolePdr: "Técnico PDR",
  roleMontador: "Montador",
  notTechnicianNote: "Su cuenta no tiene rol de técnico en ninguna empresa.",
  notLinkedNote:
    "⚠ Cuenta aún no vinculada a una ficha de técnico — pida a la oficina (Técnicos → editar → Cuenta del portal).",
  plateLabel: "Matrícula del coche",
  searchHint:
    "Escriba la matrícula O el VIN para buscar el vehículo. El botón ⇄ alterna entre los dos campos.",
  menuHome: "Inicio",
  panelsTitle: "Piezas a reparar",
  impactsWord: "impactos",
  searchBtn: "Buscar",
  searching: "Buscando…",
  noResults:
    "Ningún coche «por ejecutar» con esa matrícula. Verifique la matrícula o hable con la oficina.",
  myCommissionPdr: "Su comisión (PDR)",
  myCommissionMontage: "Su comisión (Montaje)",
  commissionTbd: "por calcular",
  montageShort: "Montaje",
  claimPdrMontage: "Tomar PDR + Montaje",
  claimPdr: "Tomar solo PDR",
  claimMontage: "Tomar el desmontaje",
  claimOkPre: "✓ Tomado:",
  myCarsTitle: "Mis coches",
  filterWeek: "Últimos 7 días",
  filterThisWeek: "Esta semana",
  filterMonth: "Último mes",
  filterAll: "Todos",
  statusPending: "Por cobrar",
  statusPaid: "Pagados",
  rowPaid: "Pagado",
  rowPaidPartial: "Pagado en parte",
  myCarsEmpty: "Aún no ha tomado ningún coche.",
  scanTitle: "Leer con la cámara",
  scanning: "Leyendo la foto…",
  scanFail: "No pude leer la foto — acérquese, evite reflejos e inténtelo de nuevo, o escríbala.",
  agendaTitle: "Agenda de la obra",
  agendaEmpty: "Nada programado en los próximos días.",
  claimDevisNoPanels:
    "Presupuesto sin tabla de piezas (importado antes del lector — pida re-subir el PDF)",
  importTitle: "Importar presupuesto (PDF)",
  importHint:
    "¿Recibió en el sitio un presupuesto que no aparece en la búsqueda? Elija el cliente de la obra y envíe el PDF — el coche entra al momento y ya puede tomarlo.",
  importClientPlaceholder: "— elegir el cliente —",
  importPickBtn: "Elegir PDF e importar",
  importing: "Importando…",
  importOkPre: "Presupuesto importado:",
  importExistsPre: "Este presupuesto YA EXISTE en Gestion — nada fue duplicado. Coche:",
  importPanelsWord: "piezas",
  importReadFail: "No pude leer el archivo — intente seleccionarlo de nuevo (fuera de zip).",
  importNoClients:
    "Ningún cliente vinculado a usted — pida a la oficina configurar el par de comisión.",
  recTitle: "Recepción del vehículo (obligatoria antes de reparar)",
  recHint:
    "Responda la franquicia y anote daños preexistentes. El jefe de obra también puede hacerlo — si ya lo hizo, el coche llega liberado.",
  recHintNoPhotos:
    "Fuera de la obra no hay fotos: indique solo si el coche tiene deducción de franquicia (obligatorio) y asuma el servicio.",
  commissionFixedBadge: "importe fijo",
  camTitlePlate: "Matrícula",
  camClose: "Cerrar",
  camTorch: "Linterna",
  camStarting: "Abriendo la cámara…",
  camAimPlate: "Encuadre la matrícula en el marco",
  camAimVin: "Encuadre el VIN en el marco",
  camOffline: "Sin conexión — sigo intentando.",
  camDenied:
    "Cámara bloqueada. Permita la cámara para este sitio en los ajustes del navegador. Mientras tanto, escríbala.",
  camUnavailable: "Cámara no disponible en este dispositivo — escríbala.",
  camNotFound: "No está en Gestion — sigo leyendo.",
  camUseAnyway: "Usar de todos modos",
  camConflictPre: "El VIN es de",
  camConflictDevis: "pero el presupuesto es de",
  camPickOne: "¿Cuál de estos coches?",
  camRetry: "Leer de nuevo",
  camType: "Escribir",
  parcOnlyPdr: "solo PDR",
  parcWithMontage: "PDR + desmontaje/montaje",
  parcChoiceLater:
    "El importe se fija cuando usted toma el coche, después de la recepción: solo PDR, o PDR + desmontaje/montaje.",
  readOnlyNote:
    "Cuenta solo de consulta: usted ve los coches que hizo y el estado de cada pago, pero no puede registrar ni cambiar nada.",
  pdrPendingNote: "Finalice el PDR de estos coches antes de tomar otro:",
  pendingTasksTitle: "Tareas pendientes",
  pendingTasksBtn: "Tareas pendientes",
  pendingTasksClose: "Cerrar",
  pendingTasksNone: "Ninguna tarea pendiente.",
  pendingTasksHint:
    "Puede cerrar y consultar sus coches, pero no toma ni agrega un coche nuevo mientras haya un PDR sin marcar como terminado.",
  prodTitle: "Mi producción",
  prodAllTime: "Total",
  prodCar: "coche",
  prodCars: "coches",
  prodPaid: "Pagado",
  prodToReceive: "por cobrar",
  prodTbdNote: "los coches con importe aún por calcular no se suman",
  noticeTitle: "Mensaje de la oficina",
  noticeAckBtn: "Entendido",
  noticeDoneBtn: "Hecho",
  myTasksTitle: "Tareas de la oficina",
  myTasksOverdue: "Atrasada",
  myTasksToday: "Hoy",
  myTasksDue: "Plazo",
  myTasksDoneBtn: "Hecho",
  myTasksLaterBtn: "Ver después",
  myTasksHint: "Toque Hecho cuando termine. Una tarea atrasada se queda aquí hasta que se haga.",
  noticeAckHint: "Entendido: vuelve en la próxima entrada · Hecho: no aparece más.",
  noticeBlockedTitle: "Portal bloqueado",
  noticeBlockedHint: "Termina las tareas pendientes o consulta a la oficina:",
  noticeBlockedWait:
    "Solo la oficina desbloquea el portal (vehículo nuevo, importación de presupuesto y escáner).",
  devisNetOfFranchise: "franquicia ya descontada",
  openCarsTitle: "Vehículos que empezaste y aún no terminaste",
  openCarsNote:
    "Tu PDR está terminado, pero el montaje aún no se registró. Termina el vehículo: registra el montaje o avisa al montador.",
  openCarsMontage: "montaje no registrado · desmontaje:",
  openCarsOpen: "Abrir",
  montageExternalBtn: "Montaje hecho por un tercero (taller)",
  montageExternalHint: "Nadie de ES/BS cobra por esta etapa.",
  montageExternalConfirm:
    "Confirmar: ¿el montaje de este coche lo hizo un tercero (taller)? Nadie de ES/BS cobrará por él.",
  montageExternalDone: "montaje hecho por un tercero (taller)",
  phaseExternalShort: "tercero (taller)",
  claimMontageOnly: "Tomar solo el desmontaje/montaje",
  filterSince: "Desde el 01/05/2026",
  filterRange: "Rango de fechas",
  degarnissageGarageBtn: "Desmontaje hecho por el taller (tercero)",
  degarnissageGarageConfirm:
    "Confirmar: ¿el desmontaje y el montaje de este coche los hizo el taller? Nadie de ES/BS cobrará por ellos.",
  degarnissageGarageDone: "Desmontaje registrado como hecho por el taller.",
  openCarsNoMontage:
    "desmontaje del presupuesto no registrado — tómalo o decláralo hecho por el taller",
  recFranchiseQ: "¿El vehículo tiene descuento de franquicia al cliente?",
  recYes: "Sí",
  recFranchiseStep: "1 · Franquicia — obligatorio",
  recFranchiseFirstHint: "Responda la franquicia para desbloquear las fotos de recepción.",
  recPhotosStep: "2 · Daños y fotos",
  recNo: "No",
  recAmountPh: "Importe de la franquicia (€ TTC)",
  recDamagesPh: "Daños/piezas rotas preexistentes (opcional, separe por comas)",
  recSaveBtn: "Guardar recepción",
  recSaving: "Guardando…",
  recSavedMsg: "Recepción guardada — el coche está liberado para reparar.",
  recDoneLabel: "Recepción hecha",
  recFranchisePre: "Franquicia:",
  recNoFranchise: "sin franquicia",
  repairedAtPre: "Asumido el",
  importAtelierPlaceholder: "— elegir el taller —",
  chkPhotoFront: "Frente",
  chkPhotoFrontRight: "Lateral frontal der.",
  chkPhotoFrontLeft: "Lateral frontal izq.",
  chkPhotoRearLeft: "Lateral trasera izq.",
  chkPhotoRearRight: "Lateral trasera der.",
  chkPhotoHood: "Capó",
  chkPhotoRear: "Trasera",
  chkNextPhotoPre: "Siguiente foto:",
  chkTakePhotoBtn: "Tomar foto",
  chkPhotoCameraBtn: "Cámara",
  chkPhotoGalleryBtn: "Galería",
  chkPhotoSourcePre: "Foto:",
  chkPhotoCancelBtn: "Cancelar",
  chkPhotosDone: "Fotos completas",
  chkFranchiseEditBtn: "Editar franquicia",
  devisHtLabel: "Presupuesto HT",
  chkClaimQ: "¿Cómo va a reparar este coche?",
  chkPhotoHoodLiner: "Forro del capó",
  chkPhotoDoorTrim1: "Guarnición puerta 1",
  chkPhotoDoorTrim2: "Guarnición puerta 2",
  chkPhotoDoorTrim3: "Guarnición puerta 3",
  chkPhotoDoorTrim4: "Guarnición puerta 4",
  chkPhotoDoorTrim5: "Guarnición puerta 5",
  chkPhotoRearLight1: "Faro trasero 1",
  chkPhotoRearLight2: "Faro trasero 2",
  chkPhotoRearLight3: "Faro trasero 3",
  montagePhotosTitle: "Fotos del desmontaje",
  montageHtLabel: "Montaje HT",
  worklogTitle: "Worklog (PDF)",
  worklogPdfBtn: "Descargar PDF",
  worklogEmpty: "Sin producción esta semana.",
  worklogWeekPre: "Semana",
  importAtelierLabel: "Taller / lugar del servicio",
  // F2 checklist — fotos guiadas + firma
  chkTitle: "Check-list del vehículo",
  chkIncompleteHint:
    "Check-list incompleto — complete los puntos de abajo para desbloquear la reparación.",
  chkCompleteBadge: "Check-list completo",
  chkMileageLabel: "Kilometraje (km)",
  chkMileagePh: "Ej.: 45200",
  chkPareBriseLabel: "Parabrisas",
  chkCielLabel: "Ciel de toit",
  chkOkBtn: "OK",
  chkCrackedBtn: "Fisurado",
  chkDefectBtn: "Con defecto",
  chkPhotosTitle: "Fotos del vehículo (obligatorias)",
  chkPhotoAngle1: "Frente izq.",
  chkPhotoAngle2: "Frente der.",
  chkPhotoAngle3: "Trasera izq.",
  chkPhotoAngle4: "Trasera der.",
  chkPhotoRoof: "Techo",
  chkPhotoDashboard: "Tablero (contacto puesto)",
  chkPhotoWindshield: "Parabrisas fisurado",
  chkPhotoHeadliner: "Ciel con defecto",
  chkPhotoFree: "Foto libre",
  chkPhotoTake: "Tomar",
  chkUploading: "Subiendo…",
  chkSignTitle: "Firma del cliente",
  chkSignHint: "Firme con el dedo en el recuadro blanco",
  chkSignNamePh: "Nombre de quien firma",
  chkSignClear: "Borrar",
  chkSignedBadge: "Firma registrada",
  chkSaveBtn: "Guardar check-list",
  chkSaving: "Guardando…",
  chkSavedMsg: "Check-list guardado.",
  importPhotoBtn: "Importar por foto / captura de pantalla",
  importPhotoReading: "Leyendo la foto…",
  importPhotoHint:
    "Una captura de pantalla funciona mejor que una foto de papel. La lectura ocurre en su dispositivo; la 1ª vez descarga el lector (~6 MB).",
  importPhotoFail:
    "No pude leer el presupuesto en la foto — intente una captura más nítida o use el PDF.",
  claimFranchisePre: "Franquicia de",
  claimFranchiseSuf: "descontada de la base de cálculo — presupuesto intacto.",
  claimFranchiseSufParticular:
    "cliente particular: factura íntegra (abono); comisiones sobre la base reducida.",
  impersonatingPre: "Viendo como",
  impersonatingBy: "por",
  impersonatingExit: "Salir de la vista",
  claimNoMontage: "Este presupuesto no tiene desmontaje — nada para el montador en este coche.",
  otherCarsTitle: "Esta matrícula ya está en Gestion, pero sin presupuesto importado:",
  otherCarsWith: "con",
  otherCarsHint:
    "Para tomar este coche hace falta el presupuesto — importe el PDF abajo o hable con la oficina.",
  montageEndPhotosTitle: "Fotos del fin del trabajo",
  phaseDemontageTitle: "Desmontaje",
  phaseMontageTitle: "Montaje",
  phaseDemontageBtn: "Desmontaje concluido",
  phaseMontageBtn: "Montaje concluido",
  phaseDemontageDone: "Desmontaje hecho",
  phaseMontageDone: "Montaje hecho",
  chkMarkDefect: "Pieza ya defectuosa",
  chkMarkBroken: "Se rompió en el trabajo",
  chkClearIssue: "Quitar la marca",
  chkRetakePhoto: "Repetir la foto",
  chkIssueNotePlaceholder: "¿Qué está mal? (opcional)",
  chkIssuesDefectSummary: "pieza(s) ya defectuosa(s)",
  chkIssuesBrokenSummary: "pieza(s) rota(s) en el trabajo",
  deposeReposeLabel: "Desmontar/Montar",
  docsBannerTitle: "Faltan sus documentos",
  docsDaysLeftPre: "Le quedan",
  docsDaysLeftSuf: "días para enviarlos.",
  docsOverdue: "Plazo vencido — envíelos hoy.",
  docsLastDay: "Último día del plazo.",
  docsIdentity: "Documento de identidad",
  docsUrssaf: "Attestation URSSAF o certificado A1",
  docsRcPro: "Seguro RC Pro",
  docsKbis: "Kbis / auto-entrepreneur",
  docsSendBtn: "Enviar",
  docsSentBadge: "enviado",
  docsSending: "Enviando…",
  docsA1: "Certificado A1 o attestation URSSAF",
  docsKbis2: "Kbis o registro de la empresa (estatutos)",
  docsIdentity2: "Documento de identidad",
  openCarBtn: "Abrir el coche",
  phaseDemontageByPre: "Desmontado por",
  phaseMontagePending: "falta el montaje",
  phaseBothDoneBy: "Desmontaje y montaje hechos por",
  takeMontageBtn: "Tomar el montaje",
  takeDemontageBtn: "Tomar el desmontaje",
  takeHint: "Usted recibe la mitad de esta etapa, a su porcentaje con el cliente.",
  claimedAlready: "Usted ya tomó este coche",
  commissionDemontage: "Desmontaje",
  commissionMontageHalf: "Montaje",
  commissionPendingHint: "por hacer",
  servicesTitle: "Prestaciones de este coche",
  servicePdrLabel: "PDR",
  showPhotosBtn: "Ver fotos",
  hidePhotosBtn: "Ocultar fotos",
  photosReception: "Recepción",
  photosDemontage: "Desmontaje",
  photosMontageEnd: "Fin del trabajo",
  carRepairedTitle: "Vehículo ya reparado",
  carRepairedHint: "Todas las prestaciones de este coche están terminadas.",
  carClosedNoTechTitle: "Coche entregado sin técnico asignado",
  carClosedNoTechHint:
    "El jefe de obra registró la entrega, pero nadie tomó este coche en el portal. Avise a la oficina para asignar el técnico en el expediente: solo así el coche entra en su lista y en su pago.",
  docsAllDone: "Documentos completos. Gracias.",
  chkMissingPre: "Falta:",
  chkMissingPhoto: "foto",
  chkMissingPhotos: "fotos",
  chkMissingSignature: "firma del cliente",
  chkMissingPareBrise: "responder el parabrisas",
  chkMissingCiel: "responder el techo interior",
  rowDemontageDone: "desmontado",
  rowMontageDone: "montado",
  foundInOtherCompanyPre: "Este coche está en la empresa",
  switchCompanyBtn: "Ver en",
  noPairTitle: "Coche encontrado, pero no está liberado para usted",
  alreadyInvoicedTitle: "El servicio de este coche ya fue facturado",
  alreadyInvoicedHint:
    "La reparación anterior está cerrada. Si el coche volvió para una nueva reparación, el nuevo devis debe entrar en el Gestion (por la oficina o con el botón de importar el devis de abajo); después aparecerá aquí para que usted lo asuma.",
  noPairHint:
    "Este coche es de un cliente con el que usted no tiene par configurado, y el cliente no está vinculado a una obra donde usted lo tenga. Pida a la oficina configurar el par o vincular el cliente a la obra.",
  phaseDoneDemontageMsg: "Coche desmontado",
  phaseDoneMontageMsg: "Coche montado",
  phaseDoneDemontageHint: "Ya está en su lista como desmontado. Falta el montaje.",
  phaseDoneMontageHint: "Trabajo terminado en este coche.",
  claimNeedsReception: "Guarde la recepción de arriba para desbloquear la toma del coche.",
  photoUploadFailPre: "La foto no subió:",
  chkPhotoHeadlinerFront: "Techo interior — delante",
  chkPhotoHeadlinerRear: "Techo interior — detrás",
  claimDemontageQ: "¿Asumir el desmontaje?",
  claimDemontageHint: "El montaje queda con usted, salvo que otro técnico lo asuma.",
  takeOwnMontageBtn: "Tomar el montaje",
  takeOwnMontageHint:
    "Desmontaje terminado. Tome el montaje cuando vaya a empezarlo — hasta entonces otro técnico puede tomarlo.",
  phaseMontageAfterDemontage: "2 · Montaje — después de terminar el desmontaje.",
  toastPdrStarted: "Servicio PDR iniciado",
  toastPdrDone: "Servicio PDR terminado",
  toastDemontageTaken: "Desmontaje asumido",
  toastDemontageDone: "Desmontaje terminado",
  toastMontageDone: "Montaje terminado",
  pdrDoneQ: "¿Terminó el PDR de este coche?",
  pdrDoneBtn: "Marcar PDR terminado",
  mycarsMarkPhasesBtn: "Marcar desmontaje / montaje (abre el coche)",
  importChantierHint:
    "El cliente sale del nombre impreso en el presupuesto y entra en la obra. Use esta opción para coche de particular.",
  recWaitingTitle: "Esperando la recepción",
  recWaitingHint:
    "En una obra, la recepción (franquicia, check-list, fotos y firma) la hace el gerente o el técnico senior; fuera de obra, el técnico PDR del coche. Después podrá tomar el servicio.",
  recIncompleteWait:
    "Recepción incompleta — quien la hizo (gerente, senior o técnico PDR) debe completarla antes de que tome el servicio.",
  importScanReading: "PDF escaneado — leyendo el texto con OCR en el dispositivo…",
  importScanPlatePrompt: "Matrícula leída del presupuesto — confirme o corrija antes de importar:",
  importScanConfirmBtn: "Importar con esta matrícula",
  importScanCancelBtn: "Cancelar",
  importScanFail:
    "No pude leer el PDF escaneado. Fotografíe el presupuesto con buena luz y use el botón de foto.",
  scanWarn_scan_ocr:
    "Presupuesto escaneado leído por OCR — verifique matrícula, cliente e importes en el documento.",
  scanWarn_scan_dsp_derived:
    "Total DSP calculado a partir del Total HT (el OCR no leyó la casilla DSP).",
  scanWarn_scan_deg_adjusted:
    "Dégarnissage ajustado según el Total HT (la casilla era ilegible para el OCR).",
  scanWarn_scan_no_panels: "Piezas e impactos no extraídos del esquema (presupuesto escaneado).",
  scanWarn_plate_confirmed: "Matrícula confirmada por usted.",
  scanWarn_scan_plate_ocr: "Matrícula leída por OCR — verifique.",
  scanWarn_scan_no_plate: "Matrícula no identificada en el documento.",
  scanWarn_scan_no_client: "Nombre del cliente no identificado.",
  scanWarn_scan_no_date: "Fecha del presupuesto no reconocida.",
  scanWarn_scan_ht_from_ttc: "Total HT calculado a partir del TTC.",
  scanWarn_scan_ht_from_sum: "Total HT calculado por la suma de las partidas.",
  scanWarn_scan_sum_mismatch:
    "La suma de las partidas difiere del Total HT — verifique el documento.",
  scanWarn_num_from_filename: "Nº de presupuesto leído del nombre del archivo.",
  scanWarn_make_model_backfilled: "Marca/modelo del coche completados a partir del presupuesto.",
  scanWarn_devis_linked_existing: "Nº de presupuesto vinculado al expediente ya existente.",
  scanWarn_car_existed: "El coche ya existía en Gestion — expediente completado, nada duplicado.",
  scanWarn_customer_created: "Cliente nuevo creado a partir del presupuesto.",
  scanWarn_customer_matched: "Cliente vinculado a un registro ya existente.",
  parcImportPdfBtn: "Importar PDF del presupuesto",
  parcCarBtn: "Coche de parc",
  parcNoneHint: "Ninguno de sus clientes tiene categorías de coche de parc — hable con la oficina.",
  parcPlateLabel: "Matrícula:",
  parcChooseClient: "— elegir el cliente —",
  parcChooseCategory: "— elegir la categoría —",
  parcYouReceive: "usted recibe",
  parcChooseAtelier: "— elegir el taller —",
  parcMakePh: "Marca",
  parcModelPh: "Modelo",
  parcCreateBtn: "Registrar coche de parc",
  parcCreatedPre: "Coche de parc registrado — haga la recepción:",
  // F-portal-busca-primeiro (auditoria UX, item 7)
  modePlate: "Matrícula",
  searchCarBtn: "Buscar el coche",
  importLink: "o importar un presupuesto (PDF)",
  weekWord: "Semana",
  sitInRepair: "En reparación",
  sitMontage: "Montaje pendiente",
  sitDone: "Terminado · por cobrar",
  navCars: "Coches",
  navWorklog: "Worklog",
  navScanner: "Escanear",
  navPayments: "Pagos",
  navMore: "Más",
  periodAria: "Período",
  statusAria: "Estado del pago",
  menuBtnAria: "Menú",
  advTitle: "Anticipos a descontar",
  advHint:
    "La empresa adelantó estos importes. Descuente el total en su próxima factura (el correo de la proforma ya muestra el importe esperado).",
  advNoneOpen: "Ningún anticipo pendiente.",
  advHistory: "ya descontados",
  advDeductedIn: "descontado en",
};

export const esLanding: Messages["landing"] = {
  navCta: "Acceder al sistema",
  techSignupLink: "Soy técnico — crear mi cuenta",
  heroEyebrow: "ERP financiero · débosselage",
  heroTitlePre: "Del expediente al contador,",
  heroTitleAccent: "en un solo lugar.",
  heroSubtitle:
    "Comisiones, facturación, conciliación bancaria y fiscalidad francesa — multiempresa, en tiempo real. El sistema de gestión hecho para la operación de reparación de granizo del grupo Storm.",
  featuresTitle: "Todo lo que la operación necesita",
  featuresSubtitle:
    "De la entrada del vehículo al cierre contable — un solo flujo, sin hojas de cálculo aparte.",
  f1t: "Expedientes y comisiones",
  f1d: "Cada reparación en un solo lugar: líneas de servicio, cascada de comisión (cliente · técnico · intermediario) y beneficio previsto, en tiempo real.",
  f2t: "Facturación completa",
  f2d: "Facturas de cliente, de técnico e intragrupo (proforma) — PDF automático, envío por correo y abonos.",
  f3t: "Conciliación bancaria",
  f3d: "Importe el extracto y concilie en pocos clics: cobros, pagos, impuestos y comisiones — con los justificantes adjuntos.",
  f4t: "Contabilidad francesa",
  f4d: "SIG, Seuil, Bilan, IVA y presupuestos en el formato contable francés — listos para el cabinet comptable.",
  f5t: "Intragrupo (intercompany)",
  f5d: "Facturación entre empresas del grupo con espejo automático y reglas de comisión coherentes.",
  f6t: "Informes para el contador",
  f6d: "Extracto conciliado e informe de facturas en PDF/CSV, con enlaces a los justificantes — generado y enviado en 1 clic.",
  f7t: "Multiempresa",
  f7d: "Gestione varias empresas del grupo con un solo selector, datos aislados y niveles de acceso por usuario.",
  f8t: "Multilingüe",
  f8d: "Interfaz en francés, portugués, español, ucraniano e inglés; los documentos del contador salen en francés.",
  b1t: "Menos hoja de cálculo, más control",
  b1d: "Del presupuesto al cobro, todo conectado — sin retrabajo ni datos dispersos.",
  b2t: "Listo para Francia",
  b2d: "IVA (incluida la autoliquidación), SIG/Bilan e informes en el formato que el contador espera.",
  b3t: "Seguro y auditable",
  b3d: "Niveles de acceso (super admin · admin · usuario · visor) y un registro de auditoría completo.",
  finalTitlePre: "¿Listo para gestionarlo todo",
  finalTitleAccent: "en un solo panel?",
  finalSubtitle: "Entre con su cuenta del grupo Storm y empiece.",
  footerRights: "Todos los derechos reservados",
};

export const esTechSignup: PagesMessages["techSignup"] = {
  subtitle: "Registro de técnico",
  intro: "Complete sus datos. Euro Storm los revisa y le abre el acceso al portal.",
  nameLabel: "Nombre completo",
  emailLabel: "Correo electrónico",
  emailHint: "Será su usuario. Allí recibirá el enlace para crear la contraseña.",
  phoneLabel: "Teléfono / WhatsApp",
  langLabel: "Idioma del portal",
  roleLabel: "Qué hace usted",
  roleDebosselage: "Técnico PDR (débosselage)",
  roleMontage: "Montador (desmontaje y montaje)",
  countryLabel: "País donde trabaja",
  submitBtn: "Enviar registro",
  sending: "Enviando…",
  successTitle: "Registro enviado.",
  successBody:
    "Euro Storm revisará sus datos. Cuando lo apruebe, recibirá un correo para crear su contraseña.",
  docsNotice:
    "Tras la aprobación, el portal le pedirá sus documentos: documento de identidad, Kbis o equivalente y — según dónde resida — el certificado de la URSSAF (residentes en Francia) o el certificado A1. Tiene 7 días para enviarlos; el trabajo no se detiene mientras tanto.",
  backToLogin: "Ya tengo cuenta",
  residenceLabel: "País de residencia / permiso de trabajo",
  residenceHint: "Esto define qué documentos le pediremos después.",
  errorRequired: "Complete nombre, correo, teléfono y país.",
};
